module.exports = {"id":"203581","name":"Iván Balliu","rating":"72","photo":"./data/images/photos/4/203581.png","club":{"name":"FC Metz","logo":"./data/images/clubs/FCMetz.png"},"positions":["DD"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/IvanBalliu0.json
// module id = 1836
// module chunks = 0